import React from 'react';

const CharacterNameContext = React.createContext();
CharacterNameContext.displayName = 'CharacterNameContext';

export default CharacterNameContext;